import { getColorScaleValueByUseCase } from "@vitality-ds/system";
import { colorUseCases } from "@vitality-ds/tokens";
var text = colorUseCases.text,
  backgrounds = colorUseCases.backgrounds;
export var getUiElementVariant = function getUiElementVariant(colorScale) {
  return {
    color: getColorScaleValueByUseCase(colorScale, text.lowContrast),
    backgroundColor: getColorScaleValueByUseCase(colorScale, backgrounds.uiElement)
  };
};
export var getSolidVariant = function getSolidVariant(colorScale) {
  return {
    color: getColorScaleValueByUseCase(colorScale, text.hiContrastOnSolidBackgrounds),
    backgroundColor: getColorScaleValueByUseCase(colorScale, backgrounds.uiElementSolid)
  };
};
export var getOnSolidBackgroundVariant = function getOnSolidBackgroundVariant(colorScale) {
  return {
    color: getColorScaleValueByUseCase(colorScale, text.hiContrastOnSolidBackgrounds),
    backgroundColor: getColorScaleValueByUseCase(colorScale, backgrounds.blanket),
    // Black alpha uses to maintain consistent indentation style
    boxShadow: "0 0 2px 1px hsla(0, 100%, 0%, 0.4) inset"
  };
};
export var getOnUiElementBackgroundVariant = function getOnUiElementBackgroundVariant(colorScale) {
  return {
    color: getColorScaleValueByUseCase(colorScale, text.lowContrast),
    backgroundColor: getColorScaleValueByUseCase(colorScale, backgrounds.uiElement_active)
  };
};
export var getOnSurfaceVariant = function getOnSurfaceVariant(colorScale) {
  return {
    color: getColorScaleValueByUseCase(colorScale, text.hiSaturation),
    backgroundColor: getColorScaleValueByUseCase(colorScale, backgrounds.uiElementOnSurface)
  };
};
export var getGhostVariant = function getGhostVariant(colorScale) {
  return {
    backgroundColor: "transparent",
    color: getColorScaleValueByUseCase(colorScale, text.lowContrast)
  };
};
export var getLinkVariant = function getLinkVariant(colorScale) {
  return {
    backgroundColor: "transparent",
    color: getColorScaleValueByUseCase(colorScale, text.hiSaturation)
  };
};